import posthog from "posthog-js";
import { getPublicConfig } from "./public-config";

const DEFAULT_POSTHOG_HOST = "https://us.i.posthog.com";

type AnalyticsValue = string | number | boolean | null | undefined;
type AnalyticsProperties = Record<string, AnalyticsValue>;

let initialized = false;
let enabled = false;
let lastPageViewPath: string | null = null;

function isBrowser(): boolean {
  return typeof window !== "undefined";
}

export function isAnalyticsEnabled(): boolean {
  return enabled;
}

export function initAnalytics(): void {
  if (initialized || !isBrowser()) {
    return;
  }

  initialized = true;
  const config = getPublicConfig();
  const posthogKey = config.posthogKey.trim();
  if (!posthogKey) {
    return;
  }

  const posthogHost = config.posthogHost.trim() || DEFAULT_POSTHOG_HOST;
  posthog.init(posthogKey, {
    api_host: posthogHost,
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
    person_profiles: "always",
    ui_host: "https://us.posthog.com",
    defaults: "2026-01-30",
  });

  enabled = true;
}

export function track(
  eventName: string,
  properties: AnalyticsProperties = {},
): void {
  if (!enabled) {
    return;
  }

  if (eventName === "tr_page_view") {
    const fullPath =
      typeof properties.full_path === "string" ? properties.full_path : null;

    if (fullPath && fullPath === lastPageViewPath) {
      return;
    }

    if (fullPath) {
      lastPageViewPath = fullPath;
    }
  }

  posthog.capture(eventName, properties);
}
